//* React
import React, { useEffect } from 'react'

//* Material UI
import { Grid } from '@material-ui/core'

//* Components
import Chirp from '../components/chirp/Chirp'
import Profile from '../components/profile/Profile'
import ChirpSkeleton from '../util/ChirpSkeleton'

//* Redux
import { useDispatch, useSelector } from 'react-redux'
import { getChirps } from '../redux/actions/dataActions'

const Home = () => {
  const dispatch = useDispatch()

  //* Chirp Data
  const { chirps, loading } = useSelector((state) => state.data)
  useEffect(() => {
    dispatch(getChirps())
  }, [dispatch])

  let recentChirpsMarkup = !loading ? (
    chirps.map((chirp) => <Chirp key={chirp.chirpId} chirp={chirp} />)
  ) : (
    <ChirpSkeleton />
  )

  return (
    <Grid container spacing={8}>
      <Grid item sm={7} xs={12}>
        {recentChirpsMarkup}
      </Grid>
      <Grid item sm={3} xs={12}>
        <Profile />
      </Grid>
    </Grid>
  )
}

export default Home
